<template>
  <div class="message_founder">
    <div v-for="item in pageCate.list" :key="item.id">
      <!-- <img src="../assets/image/1.jpg" alt="" /> -->
      <el-image :src="item.image" :preview-src-list="[item.image]" fit="cover">
      </el-image>
      <div>
        <p>{{ item.title }}</p>
        <p>{{ item.summary }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "messageFounderG",
  computed: mapGetters(["pageCate"]),
};
</script>

<style scoped lang='less'>
//  创始人寄语
.message_founder {
  > div {
    display: flex;
    background: #f3f3f3;
    padding:1vw;
    margin: 2.08vw auto;
    > .el-image {
      flex: 0 0 20%;
      margin-right:1vw;
      width: 22.08vw;
      height: 22.08vw;
      img {
        width: 22.08vw;
        height: 22.08vw;
      }
    }
    > div {
      // width: 959px;
      > p:first-child {
        font-size:  0.93vw;
        margin-top: 2.08vw;
        font-weight: bold;
        + p {
          margin-top:  0.93vw;
          font-size: 0.83vw;
          line-height: 1.8;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/go/messageFounderG.vue